import { useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  likeComment as likeCommentService,
  unlikeComment as unlikeCommentService,
} from '../../services/comment';

import { Button, LikeIcon, LikeIconOutline } from '../ui';

import { trackCommentEvent } from '../../models/comments/analytics';
import { Comment } from '../../models/comments/types';

const CommentActionLike = ({ comment }: { comment: Comment }) => {
  const [liked, setLiked] = useState(comment.isLiked);
  const [canLike, setCanLike] = useState(comment.canLike);
  const [likeCount, setLikeCount] = useState(comment.likeCount);
  const { t } = useTranslation();

  const empyLikes = likeCount == 0;

  const className = cx('comment__action', 'comment__action--like', {
    'comment__action--liked': liked,
    'comment__action--can-like': canLike || liked,
    'comment__action--like--empty': empyLikes,
  });

  const likeComment = () => {
    if (!canLike) {
      return;
    }

    trackCommentEvent('like', comment, !!comment.replyToId);

    likeCommentService(comment.contentId, comment.id);

    setLiked(true);
    setCanLike(false);
    setLikeCount(likeCount + 1);
  };

  const unlikeComment = () => {
    trackCommentEvent('unlike', comment, !!comment.replyToId);

    unlikeCommentService(comment.contentId, comment.id);

    setLiked(false);
    setCanLike(true);
    setLikeCount(Math.max(0, likeCount - 1));
  };

  const handleClick = () => {
    liked ? unlikeComment() : likeComment();
  };

  return (
    <div className={className}>
      <Button
        onClick={handleClick}
        aria-label={t('content.like', { count: 1 })}
      >
        <span className="icons">
          <LikeIconOutline />
          <LikeIcon />
        </span>

        <span className="count">{empyLikes ? null : likeCount}</span>
      </Button>
    </div>
  );
};

export default CommentActionLike;
